import React, { useEffect, useState } from 'react';
import { Table, Typography, Divider } from 'antd';
import type { TableProps } from 'antd';

const { Title } = Typography;

interface TableValuePropsType {
	tableData?: any;
}

const chengePriceFormat = (price: any) => {
	if (!price) return price;
	if (!isNaN(Number(price))) {
		price = price / 100;
	}
	return price;
};

const isJsonString = (str: any) => {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
};

const TableValue: React.FC<TableValuePropsType> = props => {
	const { tableData } = props;
	let newVal = '';
	let oldVal = '';
	if (
		tableData.op_event === '车辆押金' ||
		tableData.op_event === '违章押金' ||
		tableData.op_event === '周末价格' ||
		tableData.op_event === '工作日价格'
	) {
		oldVal = chengePriceFormat(tableData.old_val);
		newVal = chengePriceFormat(tableData.new_val);
		return <span>{`${oldVal} ${oldVal ? '->' : ''} ${newVal || '--'}`}</span>;
	}
	if (tableData.op_event === '区间价格') {
    return <div style={{ whiteSpace: 'pre-line' }}>{tableData?.holiday_price || ''}</div>
	}
	return <span>{`${tableData.old_val} ${tableData.old_val ? '->' : ''} ${tableData.new_val || '--'}`}</span>;
};

interface PropsType {
	enums?: any;
	title?: any;
	detail?: any;
}

interface TableDataType {
	op_event?: string;
	update_time?: string;
	uname?: string;
	new_val?: string;
	old_val?: string;
}

const ModifyRecord: React.FC<PropsType> = props => {
	const { title, detail } = props;

	const [data, setData] = useState([]);

	const columns: TableProps<TableDataType>['columns'] = [
		{
			title: '修改项',
			dataIndex: 'op_event',
			key: 'op_event',
			width: 120
		},
		{
			title: '提交时间',
			dataIndex: 'update_time',
			key: 'update_time',
			width: 120
		},
		{
			title: '提交人',
			dataIndex: 'uname',
			key: 'uname',
			width: 120
		},
		{
			title: '修改值',
			dataIndex: 'old_val',
			key: 'old_val',
			render: (_, record: any) => <TableValue tableData={record} />,
		},
	];

	useEffect(() => {
		setData(detail?.user_log || []);
	}, [detail]);

	return (
		<>
			<Title level={5}>{title}</Title>
			<Divider />
			<Table columns={columns} dataSource={data} rowKey={() => Math.random()} pagination={false} />
		</>
	);
};

export default ModifyRecord;
